import { render, staticRenderFns } from "./exercise.vue?vue&type=template&id=74ea3c50"
import script from "./exercise.vue?vue&type=script&lang=js"
export * from "./exercise.vue?vue&type=script&lang=js"
import style0 from "./exercise.vue?vue&type=style&index=0&id=74ea3c50&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports